import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./signInButton";
import { SignOutButton } from "./signOutButton";
import { IOSButton } from "./iOSAppDownload";

/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Navbar style={{ background: "#c9e8ff" }}>
                <Container>
                    <Navbar.Brand href="#home">Little Red Button</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {/* <Nav.Link href="https://apps.apple.com/us/app/little-red-button/id1626397720">Download the iOS App</Nav.Link> */}
                            {/* <Nav.Link href="#pricing">Pricing</Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                    {/* <a className="navbar-brand" href="/" style={{ color: "white"}}>Little Red Button</a> */}
                    {isAuthenticated ? <SignOutButton /> : <IOSButton />}
                    
                </Container>
            </Navbar>
            <br />
            <br />
            {props.children}
        </>
    );
};